import text from '../../constants/js/text.js';
import colors from '../../constants/js/colors.js';
const lightSize = ['lightL', 'lightM', 'lightS', 'lightXS'];
const inputLabelSize = ['medium', 'small', ...lightSize];
const skinColor = {
  dark: {
    disabled: colors.whiteTrans2,
    default: colors.whiteTrans7
  },
  light: {
    disabled: colors.silverTrans7,
    default: colors.silverStrong
  }
};
const textSize = {
  small: `line-height: ${text.lineHeight7}; font-size: ${text.fontSize7};`,
  medium: `line-height: ${text.lineHeight6}; font-size: ${text.fontSize6};`,
  lightXS: `line-height: ${text.lineHeight7}; font-size: ${text.fontSize7};`,
  lightS: `line-height: ${text.lineHeight6}; font-size: ${text.fontSize6};`,
  lightM: `line-height: ${text.lineHeight5}; font-size: ${text.fontSize5};`,
  lightL: `line-height: ${text.lineHeight4}; font-size: ${text.fontSize4};`
};
export { textSize, lightSize, skinColor, inputLabelSize };